const strateSolutionGestionInterventions = {
    init() {
        if ($('.strate-solution-gestion-interventions').length > 0) {
            const container = $('.strate-solution-gestion-interventions').find('.excerpt.inner_content_texte_chapitre');

            // Remove empty <p> tags
            container.find('p:empty').remove();

            // Show full text on click
            $('.js-show-full-texte').click(function () {
                $(this)
                    .parents('.texte_chapitre')
                    .find('.inner_content_texte_chapitre')
                    .removeClass('show');
                $(this)
                    .parents('.texte_chapitre')
                    .find('.full_texte')
                    .addClass('show');
                return false;
            });

            // Show excerpt on click
            $('.js-show-excerpt').click(function () {
                $(this)
                    .parents('.texte_chapitre')
                    .find('.inner_content_texte_chapitre')
                    .removeClass('show');
                $(this)
                    .parents('.texte_chapitre')
                    .find('.excerpt')
                    .addClass('show');
                return false;
            });
        }
    },
};
export default strateSolutionGestionInterventions;
